import { LayoutCenteredBody } from '#/layouts/Layout/LayoutCenteredBody';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardCreateEventRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { OrgDashboardOrgSubLayoutHandleProps } from '#/modules/orgDashboard/sub-layouts/Org/OrgDashboardOrgSubLayoutHandleProps';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardCreateEventPageContainerLoadable } from './OrgDashboardCreateEventPageContainerLoadable';

export const handle = {
  variant: 'base',
  orgDashboardSubLayoutVariant: 'base',
  darkBackground: true,
} satisfies LayoutHandleProps & OrgDashboardOrgSubLayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardCreateEventRoute>,
) {
  await OrgDashboardCreateEventPageContainerLoadable.load();
}

export default function OrgDashboardCreateEventHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return (
    <LayoutCenteredBody>
      <OrgDashboardCreateEventPageContainerLoadable />
    </LayoutCenteredBody>
  );
}
